module.exports = __webpack_public_path__ + "img/cropped-ralph-ravi-kayden-9VYBHWEoFfU-unsplash-mobile.d8d79418.webp";